<template>
  <div id="app">
    <my-nav></my-nav>
    <router-view></router-view>
    <my-footer></my-footer>
  </div>
</template>

<script>
import myNav from './components/Header'

import myFooter from './components/Footer'

export default {

  components : {myNav,myFooter},

  name: 'app'

}
</script>

<style>

@import url("./css/comm.css");

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

body{
  width:auto;
  height:auto;
  margin: 0;
  padding: 0;
}
ul {
  margin: 0;
  padding: 0;
  list-style: none;
}
</style>



// WEBPACK FOOTER //
// App.vue?ae3c91ee